import moment from "../../moment";
import { getBoardingStartDate } from "./getBoardingStartDate";

export const hasSelectedValidDateWithCoupon = (coupon, selectedDate) => {
  // start_date当日は購入可能なので、-1日で調整
  const start = moment(
    new Date(getBoardingStartDate(coupon.boarding_start_date))
  ).subtract(1, "day");
  const end = moment(new Date(coupon.boarding_end_date));

  return moment(selectedDate).isBetween(start, end);
};
